const apiUrl = process.env.VUE_APP_API_URL
import axios from 'axios'
import CryptoJS from 'crypto-js'

export default {
    async contactUsForm({ commit }, payLoad) {
        commit('setLoading', true)
        try {
            let { data } = await axios.post(apiUrl + 'auth/support', payLoad)
            commit('setSuccess', data.message)
            commit('setLoading', false)
        } catch (errors) {
            commit('setLoading', false)
            commit('setError', errors.response.data.message)
        }
    },

    // Action to verify credentials
    verifyCredentials({ commit }, payLoad) {
        commit('setLoading', true)
        return new Promise((resolve, reject) => {
            try {
                httpRequest.$auth
                    .login(payLoad)
                    .then((response) => {
                        let res = CryptoJS.AES.decrypt(
                            response.data.data,
                            process.env.VUE_APP_CRYPTO_SECERT_KEY
                        ).toString(CryptoJS.enc.Utf8)

                        res = JSON.parse(res)
                        commit('setOTP', res.profile.hasOTP)
                        commit('setLoading', false)            
                        resolve(true) // Resolve the promise with true
                    })
                    .catch(function onError(error) {
                        commit('setLoading', false)
                        commit('setError', error.response.data.message)
                        resolve(false) // Resolve the promise with false
                    })
            } catch (errors) {
                commit('setLoading', false)
                commit('setError', errors.response.data.message)
                reject(errors) // Reject the promise with errors
            }
        })
    },

    authLogin({ commit }, payLoad) {
        commit('setLoading', true)
        return new Promise((resolve, reject) => {
            try {
                httpRequest.$auth
                    .login(payLoad)
                    .then((response) => {
                        let res = CryptoJS.AES.decrypt(
                            response.data.data,
                            process.env.VUE_APP_CRYPTO_SECERT_KEY
                        ).toString(CryptoJS.enc.Utf8)

                        res = JSON.parse(res)

                        commit('setOTP', null)
                        commit('setSuccess', response.data.message)
                        commit('setToken', res.accessToken)
                        commit('setUser', res.profile)
                        commit('setLoading', false)
                        resolve(true)
                    })
                    .catch(function onError(error) {
                        commit('setLoading', false)
                        commit('setError', error.response.data.message)
                        resolve(false)
                    })
            } catch (errors) {
                commit('setLoading', false)
                commit('setError', errors.response.data.message)
                reject(false)
            }
        })
    },

    async authLogout({ commit }) {
        try {
            let { data } = await axios.post(apiUrl + 'auth/logout')
            commit('setUser', null)
            commit('setToken', null)
            commit('setSuccess', data.message)
            commit('setDataSegmentId', null)
            localStorage.removeItem('dataSegmentId')
            localStorage.removeItem('activeDataSegmentId')

            // httpRequest.$auth
            //     .logout(payLoad)
            //     .then((response) => {
            //         commit('setUser', null)
            //         commit('setToken', null)
            //         commit('setSuccess', 'You have logged out successfully.')
            //     })
            //     .catch(function onError(error) {
            //         commit('setUser', null)
            //         commit('setToken', null)
            //         commit('setError', error.message)
            //     })
        } catch (error) {
            commit('setUser', null)
            commit('setToken', null)
            commit('setError', error.response.data.message)
        }
    },

    async authChangePassword({ commit }, payLoad) {
        try {
            commit('setLoading', true)
            let { data } = await axios.post(
                apiUrl + 'auth/password/change',
                payLoad,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            'vueauth_token'
                        )}`,
                    },
                }
            )
            commit('setSuccess', data.message)
            commit('setLoading', false)
            return true
        } catch ({ response }) {
            let { data } = response
            let message = 'There is someting wrong'
            if (data.errors && Object.keys(data.errors).length) {
                message = data.errors[Object.keys(data.errors)[0]]
            } else if (data.message) {
                message = data.message
            }

            commit('setLoading', false)
            commit('setError', message)
            return false
        }
    },

    async authForgotPassword({ commit }, payLoad) {
        try {
            commit('setLoading', true)
            let { data } = await axios.post(
                apiUrl + 'auth/password/reset',
                payLoad
            )
            commit('setSuccess', data.message)
            commit('setData', data.message)
            commit('setLoading', false)
            return true
        } catch (errors) {
            commit('setLoading', false)
            commit('setError', errors.response.data.message)
        }
    },

    async authResetPassword({ commit }, payLoad) {
        try {
            commit('setLoading', true)
            let { data } = await axios.post(
                apiUrl + 'auth/password/set/' + payLoad.token,
                payLoad
            )
            commit('setSuccess', data.message)
            commit('setLoading', false)
            return true
        } catch ({ response }) {
            let { data } = response
            let message = 'There is someting wrong'
            if (data.errors && Object.keys(data.errors).length) {
                message = data.errors[Object.keys(data.errors)[0]]
            } else if (data.message) {
                message = data.message
            }

            commit('setLoading', false)
            commit('setError', message)
            return false
        }
    },

    async authCreatePassword({ commit }, payLoad) {
        try {
            commit('setLoading', true)
            let { data } = await axios.post(
                apiUrl + 'system-users/activate-account/' + payLoad.token,
                payLoad
            )
            commit('setToken', data.data.accessToken)
            commit('setUser', data.data.profile)
            commit('setSuccess', data.message)
            commit('setLoading', false)
            return true
        } catch ({ response }) {
            let { data } = response
            let message = 'There is someting wrong'
            if (data.errors && Object.keys(data.errors).length) {
                message = data.errors[Object.keys(data.errors)[0]]
            } else if (data.message) {
                message = data.message
            }

            commit('setLoading', false)
            commit('setError', message)
            return false
        }
    },
}
